import React, { useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import {
  Button,
  Avatar,
  Box,
  List,
  Text,
  Flex,
  CriteriaTag,
  DatePicker,
  Label
} from "samba-ui";
import { Link } from "react-router-dom";
import AddNewPeriscopeDashboardModal from "./AddNewPeriscopeDashboardModal";
import moment from "moment";
const DisabledBox = styled(Box)`
  opacity: 0.5;
  pointer-events: none;
`;

const ListLink = styled(Link)`
  text-decoration: none;
  display: block;
`;

const StyledCriteriaTag = styled(CriteriaTag)`
  color: white;
  background-color: ${props => (props.type === "oem" ? "#4ecbb3" : "#fb7f86")};
`;

const DashboardList = ({ dashboards, addNewAdminDashboard, user }) => {
  const isSuperOperator = user.role === "superoperator";
  const [isOpen, setIsOpen] = useState(false);
  dashboards = Object.keys(dashboards).map(id => dashboards[id]);
  dashboards = dashboards.sort((a, b) => b.id - a.id);
  const onNewPeriscopeDashboardCreate = body => {
    setIsOpen(false);
    addNewAdminDashboard(body);
  };

  return (
    <Box>
      <List.Header borderColor="#d6d6d6 !important">
        <Flex justifyContent="space-between" alignItems="center">
          <Text fontSize={1} color="secondary">
            Dashboard
          </Text>
          <Button
            disabled={isSuperOperator}
            variant="primaryBordered"
            onClick={() => setIsOpen(true)}
          >
            + New Dashboard
          </Button>
        </Flex>
      </List.Header>
      {!dashboards.length ? (
        <List.Empty>No result found!</List.Empty>
      ) : (
        dashboards.map(dashboard => {
          const {
            id,
            logo,
            name,
            type,
            campaignName,
            endDate,
            campaignTableId
          } = dashboard;
          return (
            <List.Item key={id} borderColor="#d6d6d6 !important">
              <ListLink to={`/admin/dashboards/${id}`}>
                <Flex alignItems="center">
                  <Flex alignItems="center" width={2 / 12}>
                    <Avatar
                      src={logo}
                      mr={2}
                      width={40}
                      height={40}
                      backgroundColor="white"
                    />
                    <Box>
                      <Text fontSize={1} color="palette.ink.normal">
                        {name}
                      </Text>
                    </Box>
                  </Flex>
                  <Box width={2 / 12}>
                    <StyledCriteriaTag type={type}>{type}</StyledCriteriaTag>
                  </Box>
                  {type !== "oem" && (
                    <Flex
                      alignItems="center"
                      width={8 / 12}
                      justifyContent="space-between"
                    >
                      <Box width={2 / 12}>
                        <Label preserveCase>{campaignName}</Label>
                      </Box>
                      <Box width={1 / 12}>
                        <Label preserveCase>{campaignTableId}</Label>
                      </Box>
                      <Flex
                        width={5 / 12}
                        alignItems="center"
                        justifyContent="flex-end"
                      >
                        {endDate ? (
                          <Flex alignItems="center">
                            <Box mr={3}>
                              <Text fontSize={1} color="secondary">
                                Default end date:
                              </Text>
                            </Box>
                            <DisabledBox>
                              <DatePicker
                                selectedDate={moment(endDate)}
                                onChooseDate={() => {}}
                              />
                            </DisabledBox>
                          </Flex>
                        ) : null}
                      </Flex>
                    </Flex>
                  )}
                </Flex>
              </ListLink>
            </List.Item>
          );
        })
      )}
      <AddNewPeriscopeDashboardModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onCreate={onNewPeriscopeDashboardCreate}
      />
    </Box>
  );
};

DashboardList.propTypes = {
  dashboards: PropTypes.object,
  addNewAdminDashboard: PropTypes.func.isRequired
};

export default DashboardList;
